import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { AppResponseModel } from '../AppResponseModel.model';
import { RecreateSecretModel } from '../RecreateSecretModel.model';
import { ResponseModel } from '../ResponseModel.model';
import { DataStorageService } from '../shared/data-storage.service';
import { VerifySessionModel } from '../VerifySession.model';

@Component({
  selector: 'app-welcome-header',
  templateUrl: './welcome-header.component.html',
  styleUrls: ['./welcome-header.component.css']
})
export class WelcomeHeaderComponent implements OnInit {
  isLoading = true;
  fetchError = false;
  appslist = false;
  loadedApps: AppResponseModel[] = [];
  appIdForDelete = "";
  isDeleting = false;
  appId: string = "";
  urlDelete = "";
  popoverTitle = 'Confirmation For Deletion';
  popoverMessage = "";
  appName: string = "";
  cancelClicked = false;
  recreateWait = false;
  clntId: string;
  displayNme = "";
  urlCreateSecret: string;
  createsecretClientID: string = "";
  recreatesecret = false;
  content = true;
  addApp = true;
  addApplogo = true;
  verifySessionValue: boolean = false;

  constructor(private router: Router, private http: HttpClient, private dataStorageService: DataStorageService) { }
  data: string = sessionStorage.getItem('id');
  urlFetchListApps = environment.urlFetchListApps + "applications";

  ngOnInit(): void {

    //this.dataStorageService.onVerifyServerSession(this.data).subscribe(responseData => {
    //  console.log("Response DATA " + responseData.verificationSession);
    //  this.verifySessionValue = responseData.verificationSession;
    //  console.log("this.verifySessionValue " + this.verifySessionValue);
    //  if (!this.verifySessionValue) {
    //    this.router.navigate(['landing']);
    //  }
    //})
    if (this.data != null && this.data != "abc") {
      //console.log("session id " + this.data);
      this.router.navigate(['welcome']);
      //console.log("session id " + this.data);


      this.onFetchListApps().subscribe(
        (apps) => {

          if (apps.errorMessage == "Not Authenticated ") {
            this.router.navigate(['logout']);
          }
          //console.log(apps);
          if (apps.errorMessage == "null") {





            apps.data.forEach(x => {
              //       //x.web.redirectUris =  [] ;

              //      x.web.uri = x.web.redirectUris.toString();
              x.web.uri = x.web.redirectUris.join();
              //console.log(x.web.uri);
              //console.log(x);
              // this.appId = x.id;

              this.appIdForDelete = x.id;
              //console.log("appForDelete " + this.appIdForDelete);
              this.loadedApps.push(x);





              //this.loadedApps = apps;
              //console.log(this.loadedApps[0]);

            });
            this.fetchError = false;
            this.appslist = true;
            this.isLoading = false;

          }
          else {
            this.fetchError = true;
            this.appslist = false;
            this.isLoading = false;
          }

        })
    }
    else {
      this.router.navigate(['landing']);

    }

  }

  onFetchListApps() {
    //console.log("urlFetech " + this.urlFetchListApps);
    const headers = { 'AuthKey': this.data };
    return this.http.get<ResponseModel>(
      this.urlFetchListApps, { headers }

    )



  }

  //deleting app
  onDeleteApp(id: string) {
    this.isDeleting = true;
    this.appId = id;
    // message ='Do you want to really delete?';

    //console.log("appId in delete " + this.appId);

    this.urlDelete = environment.urlDelete + "applications/" + this.appId;
    //console.log("urlDelete " + this.urlDelete);
    const headers = { 'AuthKey': this.data };
    return this.http.delete<ResponseModel>(this.urlDelete, { headers }).subscribe(deleteapps => {
      //console.log(deleteapps);

      if (deleteapps.errorMessage == "Not Authenticated ") {
        this.router.navigate(['logout']);
      }

      this.onFetchListApps().subscribe(
        (apps) => {

          //console.log(apps);
          this.loadedApps = [];
          if (apps.data != null) {
            apps.data.forEach(x => {
              //       //x.web.redirectUris =  [] ;

              //      x.web.uri = x.web.redirectUris.toString();
              x.web.uri = x.web.redirectUris.join();
              //console.log(x.web.uri);
              //console.log(x);
              // this.appId = x.id;



              this.loadedApps.push(x);
              //console.log("loadedApps " + this.loadedApps);

              this.isDeleting = false;


              //this.loadedApps = apps;
              //console.log(this.loadedApps[0]);

            });
          }
          else {
            this.isDeleting = false;
            this.appslist = false;
          }

        })






    });



  }

  getAppId(name: string) {
    this.appName = name;
    //console.log("app in getAppId " + this.appName);
    this.popoverMessage = 'Do you want to really delete app ' + this.appName;

  }

  onCreateRecreateSecret(id: string, clientId: string, displayName: string) {
    this.recreateWait = true;

    this.appId = id;
    this.clntId = clientId;
    this.displayNme = displayName;
    //console.log("appId in createsecret " + this.appId);
    this.urlCreateSecret = environment.urlCreateSecret + "applications/" + this.appId + "/addpassword";
    //console.log("urlCreateSecret " + this.urlCreateSecret);
    const headers = { 'AuthKey': this.data };
    return this.http.post<RecreateSecretModel>(this.urlCreateSecret, null, { headers }).subscribe(createsecret => {
      //console.log(createsecret);
      if (createsecret.errorMessage == "Not Authenticated ") {
        this.router.navigate(['logout']);
      }

      this.createsecretClientID = createsecret.data;
      if (createsecret.errorMessage == null) {
        this.recreateWait = false;
        this.appslist = false;
        this.addApplogo = false;
        this.content = false;
        this.recreatesecret = true;


      }
    })

  }



}
